import { Button } from 'antd';
import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import VSmall from '../../static/comment_v_small.svg';
import appIcon from '../../static/comment_soft.svg';
import specialIcon from '../../static/comment_zt.svg';
import { getStrLen } from '../../utils/utils';
import { logging } from './../../actions/log';
import styles from './MyComt.module.less';
import ComtScore from './Score';
import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function MyComt({ releaseInfo, onUpdate }) {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [comtCon, setComtCon] = useState({});
  const [contentInfo, setContentInfo] = useState({});
  const [showAll, setShowAll] = useState(true);

  useEffect(() => {
    if (releaseInfo) {
      let { commentContent } = releaseInfo;
      if (commentContent) {
        setComtCon(commentContent);
        if (commentContent.contentInfo) {
          setContentInfo(commentContent.contentInfo);
        }
      }
    }
  }, [releaseInfo]);

  // useEffect(() => {
  //   if (contentInfo) {
  //     let { appList, specialList, imgs, text } = contentInfo;
  //     if (
  //       (appList && appList.length > 0) ||
  //       (specialList && specialList.length > 0) ||
  //       (imgs && imgs.length > 0) ||
  //       (text && getStrLen(text) > 80)
  //     ) {
  //       setShowAll(false);
  //     }
  //   }
  // }, [contentInfo]);

  return (
    <div className={styles.MyComt}>
      <div className="title">我的评论</div>
      <div className="comt-head">
        <div className="comt-info">
          <div className="avatar-box">
            <img className="user-avatar" src={comtCon.profilePicUrl} alt="" />
            {comtCon.isV !== 0 && <img className="user-v" src={VSmall} alt="" />}
          </div>
          <div className="comt-fold">
            <div className="user-name">
              <div className="name">{comtCon.nickName}</div>
              <ComtScore
                score={comtCon.scoreInfo?.score}
                style={{ width: 9, height: 9, marginRight: 3, cursor: 'default' }}
                editable={false}
              />
              {comtCon?.state?.finalState === 0 && <div className="comt-state">审核中</div>}
            </div>
            {showAll ? (
              <div className="comt-des">
                <div className="des-time">{comtCon?.updateTime || '刚刚'}</div>
                <div className="des-device">
                  <i className={`iconfont icon-shebeixinxi`} />
                  {comtCon?.deviceInfo?.mt || ''}
                </div>
              </div>
            ) : (
              <div className="fold-con">
                <div
                  className={classNames('text', !contentInfo.text && 'default')}
                  dangerouslySetInnerHTML={{
                    __html: contentInfo.text || '暂未填写评论内容...',
                  }}
                />
                <span
                  className="open-btn"
                  onClick={() => {
                    setShowAll(true);
                    dispatch(
                      logging({
                        category: 'C',
                        action: 'Comment_More',
                        param2: {
                          commentId: comtCon?.id,
                          softid: comtCon?.bizEntityId,
                          source: logInfoData.source,
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                        },
                      }),
                    );
                  }}
                >
                  展开
                </span>
              </div>
            )}
          </div>
        </div>
        {comtCon?.state?.finalState === 1 && (
          <Button
            className="update-btn"
            onClick={() => {
              onUpdate && onUpdate();
              dispatch(
                logging({
                  category: 'C',
                  action: 'Comment_Update',
                  param2: {
                    commentId: comtCon?.id,
                    id: comtCon?.bizEntityId,
                    source: logInfoData.source,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  },
                }),
              );
            }}
          >
            更新评论
          </Button>
        )}
      </div>
      {showAll && contentInfo && (
        <div className="comt-all">
          <div className="comt-labels">
            {contentInfo?.labelCodes?.map(item => {
              return (
                <div key={item.angleCode} className="comt-label-item">
                  #{item?.starLabels?.name}
                </div>
              );
            })}
          </div>
          <div
            className={classNames('all-con', !contentInfo.text && 'default')}
            dangerouslySetInnerHTML={{
              __html: contentInfo.text || '暂未填写评论内容...',
            }}
          />
          {/* {contentInfo.imgs && (
            <div className="img-box">
              {contentInfo.imgs.map((el, idx) => {
                return <img alt="" src={el} key={idx} />;
              })}
            </div>
          )} */}
          {/* {(contentInfo.appList || contentInfo.specialList) && (
            <div className="tag-box">
              {contentInfo.appList.map((soft, idx) => {
                return (
                  <div className="tag-item" key={idx}>
                    <img alt="" src={soft.logoFile || appIcon} className="tag-icon" />
                    <span className="soft-name">{soft.name}</span>
                  </div>
                );
              })}
              {contentInfo.specialList.map((special, idx) => {
                return (
                  <div className="tag-item" key={idx}>
                    <img alt="" src={specialIcon} className="tag-icon" />
                    <span
                      className="special-name"
                      dangerouslySetInnerHTML={{
                        __html: special.name,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )} */}
        </div>
      )}
    </div>
  );
}

export default memo(MyComt);
